module.exports = {
  1: '0xC4ad1c6fBe2794a276C09dc8AadF7F4cF79Df9E1',
  56: '0xC4ad1c6fBe2794a276C09dc8AadF7F4cF79Df9E1',
  137: '0xC4ad1c6fBe2794a276C09dc8AadF7F4cF79Df9E1',
  8453: '0xC4ad1c6fBe2794a276C09dc8AadF7F4cF79Df9E1',
  42161: '0xC4ad1c6fBe2794a276C09dc8AadF7F4cF79Df9E1',
  43114: '0xC4ad1c6fBe2794a276C09dc8AadF7F4cF79Df9E1',
  59144: '0xC4ad1c6fBe2794a276C09dc8AadF7F4cF79Df9E1',
  11155111: '0xDe1Ebf9b429F5066FD060F86847657e29bD49Bb0',
}
